module.exports = __webpack_public_path__ + "media/bootstrap-icons/heart-01032e98.svg";